import { ServiceRotationTypeOption } from '@mark43/cad-api';
import { FormRow } from '@cad-arc';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { ServiceRotationFormType } from './types';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export function ServiceRotationFormTopSection({
    serviceTypeOptions,
    isTowRotation,
}: {
    serviceTypeOptions: ServiceRotationTypeOption[];
    isTowRotation: boolean;
}) {
    const { enhancedServiceRotation: isEnhancedServiceRotationEnabled } = useEnabledFeatures();
    const form = useFormContext<ServiceRotationFormType>();
    const serviceType = useWatch({
        control: form.control,
        name: 'serviceRotationTypeOption',
    });
    const rotationAreaDropdownOptions =
        serviceType?.[
            isEnhancedServiceRotationEnabled
                ? 'serviceRotationAreaOptions'
                : 'serviceRotationListOptions'
        ] ?? [];
    const capabilityOptions = serviceType?.serviceRotationTypeCapabilityOptions ?? [];
    return (
        <>
            <FormSelect
                control={form.control}
                label={isTowRotation ? 'Tow Type' : 'Service Type'}
                rules={{ required: 'Required' }}
                name="serviceRotationTypeOption"
                options={serviceTypeOptions}
                isClearable={false}
            />
            <FormRow>
                <FormSelect
                    label="Rotation Area"
                    name={
                        isEnhancedServiceRotationEnabled
                            ? 'serviceRotationArea'
                            : 'serviceRotationList'
                    }
                    control={form.control}
                    rules={{ required: 'Required' }}
                    options={rotationAreaDropdownOptions}
                    length="md"
                />
                <FormSelect
                    label="Capability"
                    name="serviceRotationTypeCapability"
                    control={form.control}
                    options={capabilityOptions}
                    length="md"
                />
            </FormRow>
        </>
    );
}
